import { FileXls, X } from "@phosphor-icons/react";
import { STATUS_LABELS, STATUS_ORDER } from "@/lib/api";

export default function KanbanExportModal({ counts, exportCols, setExportCols, onSubmit, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="glass max-w-sm w-full p-6" onClick={(e) => e.stopPropagation()} data-testid="kanban-export-modal">
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="overline text-zinc-500">EXPORTAR PARA EXCEL</div>
            <h2 className="font-head text-xl font-black">Escolha as colunas</h2>
          </div>
          <button onClick={onClose} data-testid="kanban-export-close"><X size={20} /></button>
        </div>
        <label className="flex items-center gap-2 border border-black bg-zinc-50 px-3 py-2 mb-2 cursor-pointer font-bold text-sm">
          <input
            type="checkbox"
            checked={exportCols.size === STATUS_ORDER.length}
            onChange={(e) => setExportCols(e.target.checked ? new Set(STATUS_ORDER) : new Set())}
            data-testid="kanban-export-check-all"
          />
          Quadro inteiro (todas as colunas)
        </label>
        <div className="space-y-1 mb-4">
          {STATUS_ORDER.map((s) => (
            <label key={s} className="flex items-center justify-between gap-2 border border-zinc-300 px-3 py-1.5 cursor-pointer text-sm hover:border-black">
              <span className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={exportCols.has(s)}
                  onChange={(e) => {
                    const next = new Set(exportCols);
                    if (e.target.checked) next.add(s); else next.delete(s);
                    setExportCols(next);
                  }}
                  data-testid={`kanban-export-check-${s}`}
                />
                {STATUS_LABELS[s]}
              </span>
              {counts && <span className="font-mono text-xs text-zinc-500">{counts[s] ?? 0}</span>}
            </label>
          ))}
        </div>
        <div className="flex gap-2">
          <button type="button" className="btn btn-ghost flex-1" onClick={onClose}>Cancelar</button>
          <button
            type="button"
            className="btn flex-1"
            onClick={onSubmit}
            disabled={exportCols.size === 0}
            data-testid="kanban-export-submit"
          >
            <FileXls size={16} weight="bold" /> Exportar ({exportCols.size})
          </button>
        </div>
      </div>
    </div>
  );
}
